import { CopyAltLight, Paste } from '@repo/go-icons';
import { clsx } from 'clsx';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import styles from '../BasicParameters.module.scss';
import type { BasicParametersStore } from '../BasicParameters.store';

type Props = {
  store: BasicParametersStore;
};

export const ActionsButtons = observer(function ActionsButtons({ store }: Props) {
  const { t } = useTranslation();
  const { logsIndex, clipboard, saveToClipboard, pasteFromClipboard, applyToAllWellbores, isApplyingToAllBoreholess } =
    store;

  const actionsButtons: Array<{
    text: string;
    icon: (classname: string) => ReactNode;
    handleClick: () => void;
    disabled?: boolean;
  }> = useMemo(
    () => [
      {
        text: 'applyToAllBoreHoles',
        icon: (classname) => <Paste className={classname} />,
        disabled: isApplyingToAllBoreholess,
        handleClick: () => {
          applyToAllWellbores();
        },
      },
      {
        text: 'copyAll',
        icon: (classname) => <CopyAltLight className={classname} />,
        handleClick: () => {
          saveToClipboard();
        },
      },
      {
        text: 'paste',
        icon: (classname) => <Paste className={classname} />,
        disabled: clipboard.parameters.length === 0 || clipboard.type !== logsIndex,
        handleClick: () => {
          pasteFromClipboard();
        },
      },
    ],
    [clipboard, logsIndex, applyToAllWellbores, saveToClipboard, pasteFromClipboard, isApplyingToAllBoreholess],
  );

  return (
    <>
      {actionsButtons.map((action) => (
        <div
          onClick={action.handleClick}
          key={action.text}
          className={clsx(styles.actionWrapper, action.disabled && styles.actionWrapper__disabled)}
        >
          <div>{action.icon(clsx(styles.actionIcon))}</div>
          <p>{t(`settings:${action.text}`)}</p>
        </div>
      ))}
    </>
  );
});
